import { render, staticRenderFns } from "./SettingRoleList.vue?vue&type=template&id=82dcd9d8&"
import script from "./SettingRoleList.vue?vue&type=script&lang=js&"
export * from "./SettingRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports